import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

import { CommonModule } from '@angular/common';
import { DialogService } from 'src/services/dialog/dialog.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { version, commitHash } from 'src/environments/buildInfo';
import { AuthService } from 'src/services/auth/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { SettingsMenuComponent } from 'src/app/components/settings-menu/settings-menu.component';
import { SettingsForPrefundProComponent } from '../../app/components/settings-for-prefund-pro/settings-for-prefund-pro.component';
import * as env from 'src/environments/environment';
import { SettingsForExtraFeaturesComponent } from 'src/app/components/settings-for-extra-features/settings-for-extra-features.component';
import { SettingsForAboutComponent } from '../../app/components/settings-for-about/settings-for-about.component';
import { SettingsForAccountComponent } from 'src/app/components/settings-for-account/settings-for-account.component';
import { SettingsForAdvancedComponent } from '../../app/components/settings-for-advanced/settings-for-advanced.component';
import { MobileNavbarComponent } from '../mobile-navbar/mobile-navbar.component';
import { SettingsForPreferencesComponent } from 'src/app/components/settings-for-preferences/settings-for-preferences.component';

interface SettingsData {
  state: string;
}

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    SettingsMenuComponent,
    SettingsForPrefundProComponent,
    SettingsForExtraFeaturesComponent,
    SettingsForAboutComponent,
    SettingsForAccountComponent,
    SettingsForAdvancedComponent,
    MobileNavbarComponent,
    SettingsForPreferencesComponent,
  ],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  state: string = 'preferences';

  env = env;

  constructor(
    public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public injectedData: SettingsData,
    private matDialogRef: MatDialogRef<SettingsComponent>,
    private dialogService: DialogService,
    private _snackBar: MatSnackBar
  ) {
    if (this.injectedData.state) {
      this.state = this.injectedData.state;
    }
  }

  async logout() {
    if (confirm('Are you sure you want to log out?')) {
      await this.authService.logout();
    }
  }

  async login() {
    this.matDialogRef.close({ shouldOpenLogin: true });
  }

  getStateTitle() {
    switch (this.state) {
      case 'prefund_pro':
        return 'Prefund Pro';

      default:
        return this.state;
    }
  }
}
